import AbstractEntity, {AbstractEntityBuilder} from "~/ts/library/AbstractEntity";
import {computed, ModelRef, Ref, ref, watch} from "vue";


export default function useObjectModel<T>(
    modelFromComponent: ModelRef<T | undefined>/* | Readonly<ExtractPropTypes<ReturnType<typeof propFunc<T>>>>*/,
    getDefaultValue?: () => T | undefined,
    initializeCallback?: (model: Ref<T | undefined>) => void,
    abstractEntityBuilder?: AbstractEntityBuilder<any>
) {
    let model = ref<T>();

    if (getDefaultValue == null) {
        getDefaultValue = () => undefined;
    }

    function initializeModel() {
        let changed = true;
        if (modelFromComponent.value == null) {
            model.value = getDefaultValue!();
        } else {
            let defaultValue = getDefaultValue!();
            changed = false;
            for (let key in defaultValue) {
                if (defaultValue.hasOwnProperty(key) && !modelFromComponent.value.hasOwnProperty(key)) {
                    model.value = {...getDefaultValue!() as any, ...modelFromComponent.value as any};
                    changed = true;
                    break;
                }
            }
            if (!changed) {
                model.value = modelFromComponent.value/* as T*/;
            }
        }

        if (abstractEntityBuilder && model.value && !(model.value instanceof (abstractEntityBuilder as typeof AbstractEntity))) {
            //@ts-ignore
            model.value = abstractEntityBuilder.new(model.value);
            changed = true;
        }

        if (changed) {
            modelFromComponent.value = model.value;
            //instance.$emit("input", model.value);
        }

        if (initializeCallback) {
            initializeCallback(model);
        }
    }

    initializeModel();

    watch(computed(() => modelFromComponent.value), () => {
        if (modelFromComponent.value != model.value) {
            initializeModel();
        }
    }, {deep: true});

    return computed({
        get(): T | undefined {
            return model.value;
        },
        set(value: T) {
            model.value = value;
            modelFromComponent.value = value;
        }
    });
}